// import * as Sentry from '@sentry/browser';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';

// Commented this code as sentry got decommissioned
// if (process.env.NODE_ENV === 'production') {
//   Sentry.init({
//     dsn: process.env.REACT_APP_SENTRY_URL,
//     environment: process.env.NODE_ENV,
//     release: `love-ui-${process.env.REACT_APP_GIT_SHA || ''}`,
//   });
// }

ReactDOM.render(<App />, document.getElementById('root'));
